


export const reduceSum = (sum, current) => sum + current